import { useEffect } from 'react'
import { Icon } from '@iconify/react'
import { Overlay } from '../styles/ConfirmPinModalStyle'
import { Body, Dialog, Divider, Footer, Header } from '../styles/BlockUserModalStyle'

interface Props {
   open: boolean
   username: string
   isBlocked?: boolean
   onClose: () => void
   onConfirm?: () => void
}

export default function BlockUserModal({ open, username, isBlocked = false, onClose, onConfirm }: Props) {
   useEffect(() => {
      function esc(e: KeyboardEvent) { if (e.key === 'Escape') onClose() }
      if (open) window.addEventListener('keydown', esc)
      return () => window.removeEventListener('keydown', esc)
   }, [open, onClose])

   if (!open) return null

   return (
      <Overlay onClick={onClose}>
         <Dialog onClick={e => e.stopPropagation()} role='dialog' aria-modal='true' aria-labelledby='block-title'>
            <Header>
               <h2 id='block-title'>
                  <Icon icon={isBlocked ? 'solar:check-circle-linear' : 'solar:forbidden-linear'} width={18} className={isBlocked ? 'text-[#4CAF50]' : 'text-[#DD524D]'} />
                  {isBlocked ? 'Unblock user' : 'Block user'}
               </h2>
               <button aria-label='Close' onClick={onClose}><Icon icon='material-symbols:close' width={20} /></button>
            </Header>
            <Body>
               <p>
                  {isBlocked ? (
                     <>
                        Are you sure you want to unblock <span className='font-semibold'>@{username}</span>.
                        <span className='text-[#6D6D72]'> Once unblocked, they will be able to log in, access their account, and complete transactions again</span>
                     </>
                  ) : (
                     <>
                        Are you sure you want to block <span className='font-semibold'>@{username}</span>.
                        <span className='text-[#6D6D72]'> Once blocked, they won't be able to log in, access their account, or complete transactions. You can always unblock them later from the user management page</span>
                     </>
                  )}
               </p>
            </Body>
            <Divider />
            <Footer>
               <button className='cancel' onClick={onClose}>Cancel</button>
               <button className={isBlocked ? 'confirm' : 'danger'} onClick={() => { onConfirm?.() }}>{isBlocked ? 'Unblock' : 'Block'}</button>
            </Footer>
         </Dialog>
      </Overlay>
   )
}
